import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import Autoplay from 'embla-carousel-autoplay';
import useEmblaCarousel from 'embla-carousel-react';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { BREAKPOINTS } from '@/constants';
import { useAutoplayOnInView } from '@/hooks/useAutoplayOnInView';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { RecentOrderGiftListItem } from './RecentOrderGiftListItem';
import { RecentOrderGiftListItemLoading } from './RecentOrderGiftListItemLoading';
import type { RecentOrderGiftItem } from './RecentOrderGiftsSection';
interface RecentOrderGiftListProps {
  isLoading: boolean;
  listItems: RecentOrderGiftItem[][];
  onSlideChange?: (index: number) => void;
}
export const RecentOrderGiftList = t0 => {
  const $ = _c(17);
  const {
    isLoading,
    listItems,
    onSlideChange
  } = t0;
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      threshold: 0.3
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    ref: inViewRef,
    inView
  } = useInView(t1);
  const t2 = isDesktopViewport ? "y" : "x";
  let t3;
  if ($[1] !== t2) {
    t3 = {
      loop: true,
      axis: t2,
      align: "start"
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [Autoplay({
      delay: 3000,
      stopOnInteraction: false
    })];
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t3, t4);
  useAutoplayOnInView(emblaApi, inView);
  let t5;
  let t6;
  if ($[4] !== emblaApi || $[5] !== onSlideChange) {
    t5 = () => {
      if (!emblaApi) {
        return;
      }
      const handleSelect = () => {
        const index = emblaApi.selectedScrollSnap();
        onSlideChange?.(index);
      };
      emblaApi.on("select", handleSelect);
      return () => {
        emblaApi.off("select", handleSelect);
      };
    };
    t6 = [emblaApi, onSlideChange];
    $[4] = emblaApi;
    $[5] = onSlideChange;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  useEffect(t5, t6);
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cn("w-full rounded-xxlarge border border-O-300 bg-Gray-white px-32 py-28", "mobile-tablet:border-none mobile-tablet:p-0");
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== emblaApi || $[10] !== emblaRef || $[11] !== isLoading || $[12] !== listItems) {
    t8 = isLoading ? <div className={cn("h-140 w-full", "mobile-tablet:!h-fit mobile-tablet:px-20")}><ul className={cn("grid grid-cols-3 gap-x-40", "mobile-tablet:flex mobile-tablet:flex-col mobile-tablet:gap-16")}><RecentOrderGiftListItemLoading /><RecentOrderGiftListItemLoading /><RecentOrderGiftListItemLoading /></ul></div> : <div className={cn("h-140 w-full overflow-hidden", "mobile-tablet:!h-fit mobile-tablet:px-20")} ref={emblaRef}><div className={cn("flex h-full flex-col", "mobile-tablet:h-auto mobile-tablet:flex-row")}>{listItems.map((chunk, chunkIndex) => <div key={chunkIndex} className={cn("mb-12 min-h-0 flex-[0_0_100%]", "mobile-tablet:mb-0 mobile-tablet:mr-32 mobile-tablet:min-w-0 mobile-tablet:flex-[0_0_335px] mobile-tablet:last:mr-0")} onClick={() => {
          emblaApi?.plugins()?.autoplay?.stop();
        }}><ul className={cn("grid grid-cols-3 gap-x-40", "mobile-tablet:flex mobile-tablet:flex-col mobile-tablet:gap-16")}>{chunk.map((t9, index_0) => {
              const {
                mainImageUrl,
                institutionName,
                productNumber,
                productName,
                reviewCount,
                reviewRating,
                createAt,
                productSlugId
              } = t9;
              return <RecentOrderGiftListItem key={`${chunkIndex}-${index_0}`} mainImageUrl={mainImageUrl} institutionName={institutionName} productNumber={productNumber} slugId={productSlugId} productName={productName} reviewCount={reviewCount} reviewRating={reviewRating} createAt={createAt} priority={chunkIndex === 0} />;
            })}</ul></div>)}</div></div>;
    $[9] = emblaApi;
    $[10] = emblaRef;
    $[11] = isLoading;
    $[12] = listItems;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== inViewRef || $[15] !== t8) {
    t9 = <div ref={inViewRef} className={t7}>{t8}</div>;
    $[14] = inViewRef;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};